import React, { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "components/navbar/Navbar";
import Footer from "components/Footer/Footer";
import Birdy from "components/ChatBot/Birdy";
import CookieConsent from "components/CookieConsent";
import Cookies from "js-cookie";
import axios from "axios";

const PublicLayout = ({ children }) => {
  const location = useLocation();
  const [showCookiePopup, setShowCookiePopup] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const cookieName = "visitor_uid";
    const existingUid = Cookies.get(cookieName);

    const hitCounterAPI = async (uid) => {
      try {
        const url = uid
          ? `https://service.infohubinnovations.com/contactus/counters/teachwings.com/increment?uid=${uid}`
          : `https://service.infohubinnovations.com/contactus/counters/teachwings.com/increment`;

        const response = await axios.put(url);
        const newUid = response?.data?.uuid;

        if (newUid && !uid) {
          Cookies.set(cookieName, newUid, { expires: 365 });
          setShowCookiePopup(true);
        }
      } catch (error) {
        console.error("Error hitting counter API:", error);
      }
    };

    hitCounterAPI(existingUid);
  }, []);

  const handleAcceptCookies = () => {
    setShowCookiePopup(false);
  };

  return (
    <React.Fragment>
      <Navbar />
      <Suspense
        fallback={
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="flex justify-center items-center w-full h-screen"
          >
            <motion.div
              animate={{
                rotate: 360,
                transition: { repeat: Infinity, duration: 2 },
              }}
              className="w-16 h-16 border-4 border-t-4 border-gray-300 border-t-transparent rounded-full"
            />
          </motion.div>
        }
      >
        {children}
        <Footer />
        <Birdy />
        {showCookiePopup && <CookieConsent onAccept={handleAcceptCookies} />}
      </Suspense>
    </React.Fragment>
  );
};

export default PublicLayout;
